import { api } from '@/lib/api/client';
import type { AuthUser } from '@/features/auth/AuthContext';
import {
  demoLogin,
  demoLogout,
  demoRefreshSession,
  demoSignup,
} from '@/pages/admin/demo/auth/demoAuth';

export interface AuthSession {
  user: AuthUser;
  accessToken: string;
}

/** Match admin demo — auth stays on the frontend, no backend hit. */
const USE_DEMO = true;

export function refreshSession(): Promise<AuthSession> {
  if (USE_DEMO) return demoRefreshSession();
  return api.post<AuthSession>('/auth/refresh').then((r) => r.data);
}

export function login(email: string, password: string): Promise<AuthSession> {
  if (USE_DEMO) return demoLogin(email, password);
  return api.post<AuthSession>('/auth/login', { email, password }).then((r) => r.data);
}

export function signup(name: string, email: string, password: string): Promise<AuthSession> {
  if (USE_DEMO) return demoSignup(name, email, password);
  return api.post<AuthSession>('/auth/signup', { name, email, password }).then((r) => r.data);
}

export function logout(): Promise<void> {
  if (USE_DEMO) return demoLogout();
  return api.post('/auth/logout').then(() => undefined);
}
